export default __webpack_public_path__ + "static/media/expand.9a9d3a8e.svg";